import header from "./korrektur-eines-grundrissplans.jpg";
import section1 from "./grundrissplan.jpg";
import section2 from "./grundrissplan-am-laptop.jpg";
import section3 from "./grundrisplan-wird-zeichnerisch-ergaenzt.jpg";
import section4 from "./blueprint.jpg";
import section5 from "./grundrissplaene-beispiele.webp";
import section6 from "./papierrollen-mit-grundrissplaenen.jpg";
import section7 from "./mehrere-leute-planen-grundrisse.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
